import * as ReactDOM from 'react-dom';
import './index.scss';
import App from './App';

import './index.css';
import { Amplify } from 'aws-amplify'; // Nota el uso de importación nombrada
import aws_config from './aws-exports';
import { CssBaseline } from '@material-ui/core';

// Configuración de Amplify
Amplify.configure(aws_config);

ReactDOM.render(
  <CssBaseline><App /></CssBaseline>,
  document.getElementById('root')
);
